<div *ngIf="multiTenant.getDomainClass() !== 'mquovideo' && multiTenant.getDomainClass() !== 'actuvideo' && multiTenant.getDomainClass() !== 'playbacpresse'"
  class="content-container {{ multiTenant.getDomainClass() }}">
  <h1 class="font-weight-light">
    <ng-container [ngSwitch]="multiTenant.getDomainClass()">
      <ng-container *ngSwitchCase="'lepq'">
        <i>Le Petit Quotidien</i> est le seul quotidien pour enfants <span class="white-space-nowrap">(7-10 ans)</span> en France
      </ng-container>
      <ng-container *ngSwitchCase="'mquo'">
        <i>Mon Quotidien</i> est le seul quotidien pour enfants (10-13 ans) en France
      </ng-container>
      <ng-container *ngSwitchCase="'actu'">
        L’unique journal « quoti-hebdo » en France pour les 13-20 ans
      </ng-container>
      <ng-container *ngSwitchCase="'aeco'">
        <i>L'ÉCO</i> est le seul hebdo économique écrit pour les 15-20 ans en France
      </ng-container>
      <ng-container *ngSwitchCase="'mlwk'">
        <i>My Little Weekly</i> est le seul journal (hebdo) en anglais pour enfants débutants <span class="white-space-nowrap">(au primaire ou au collège)</span>
      </ng-container>
      <ng-container *ngSwitchCase="'mlne'">
        <i>My Little Weekly News</i> est le seul journal (hebdo) en anglais pour enfants débutants<br>(au primaire ou au collège)
      </ng-container>
      <ng-container *ngSwitchCase="'week'">
        <i>My Weekly</i> est le seul journal (hebdo) en anglais pour ados non débutants<br>(collège-lycée-université)
      </ng-container>
      <ng-container *ngSwitchCase="'mwne'">
        <i>My Weekly News</i> est le seul journal (hebdo) en anglais pour ados non débutants <span class="white-space-nowrap">(collège-lycée-université)</span>
      </ng-container>
      <ng-container *ngSwitchCase="'woch'">
        <i>Meine Woche</i> est le seul journal (hebdo) en allemand pour ados non débutants <span class="white-space-nowrap">(collège-lycée-université)</span>
      </ng-container>
      <ng-container *ngSwitchCase="'sema'">
        <i>Mi Semanal</i> est le seul journal (hebdo) en espagnol pour ados non débutants <span class="white-space-nowrap">(collège-lycée-université)</span>
      </ng-container>
    </ng-container>
  </h1>
</div>
